<script>
  import { user } from '../../models/user.js'
  import { cart } from '../../models/cart.js'
  import { subscription } from '../../models/subscription.js'
  import { puzzlePack } from '../../models/puzzlePack.js'
  import { scrollToY } from '../../services/utilities.js'
  import CartList from '../../components/CartList.svelte'
  import RentalQuota from '../../components/RentalQuota.svelte'
  import RentalQuotaSubscription from '../../components/RentalQuotaSubscription.svelte'
  import Alert from '../../components/Alert.svelte'

  let cartErr = ''
  $: loggedIn = $user && $user.username

  async function checkout() {
    await cart.syncCartData($cart, false)
    let validCart = await validate()

    if (validCart) {
      window.location.href = '/checkout'
    } else {
      // scroll to top to see erorrs
      scrollToY(0)
    }
  }

  async function validate() {
    cartErr = ''

    let result = await cart.validateCart($cart)

    if (!result.valid) {
      cartErr = result.message
    }
    return result.valid
  }
</script>

<style type="text/less">
  .cart {
    max-width: var(--content-width);
    margin: auto;
    padding: var(--spacing-sm);
  }

  .cart-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: var(--line-height-lg);
    padding: var(--spacing-sm);
    margin: 0;

    a:first-child {
      margin-right: auto;
    }
  }

  @media (max-width: 500px) {
    .cart-actions {
      display: block;

      .btn {
        display: block;
        width: 100%;
        margin: var(--spacing-sm) 0;
      }
    }
  }

  @media (min-width: 800px) {
    .cart {
      padding: var(--spacing);
    }
  }
</style>

<section class="cart">
  <h1>Your Cart</h1>

  {#if cartErr || $puzzlePack.errorMsg}
    <p>
      <Alert type="danger" icon="warning">
        {cartErr || $puzzlePack.errorMsg}
      </Alert>
    </p>
  {/if}

  <RentalQuota />
  <RentalQuotaSubscription
    subscription={$subscription}
    clearError={subscription.clearError} />

  <CartList />

  {#if !loggedIn && ($puzzlePack.initialized || $cart.some((p) => p.product_type.name === 'Ticket'))}
    <p>
      <Alert type="danger" icon="warning">
        You must
        <a href="/login?referrer={window.location.pathname}">sign in</a>
        or
        <a href="/register?referrer={window.location.pathname}">
          create an account
        </a>
        to order a puzzle pack, subscriptions, or event tickets.
      </Alert>
    </p>
  {/if}

  <div class="cart-actions card">
    <a href="/rent">
      <svg class="icon">
        <use href="/icons.svg#keyboard_arrow_left" />
      </svg>
      Continue Shopping
    </a>

    {#if !loggedIn && $cart.length}
      <a href="/login?referrer={window.location.pathname}" class="btn">
        Sign In
      </a>
    {/if}

    <button
      class="btn"
      class:btn-outline={!loggedIn}
      disabled={$cart.length === 0 || (!loggedIn && ($puzzlePack.initialized || $cart.some((p) => p.product_type.name === 'Ticket')))}
      on:click|stopPropagation={checkout}>
      <svg class="icon">
        <use href="/icons.svg#https" />
      </svg>
      Checkout
      {#if !loggedIn}as Guest{/if}
    </button>
  </div>
</section>
